import axios from "axios"
import React, {Component} from "react"
import ApiHelper from "src/ApiHelper"
import DeveloperPortalLogsRow from "src/components/table/DeveloperPortalLogsRow"
class DeveloperPortalArthScoreFactors extends Component{
    constructor(props){
        super(props)
        this.state = {
            constants: {},
            constantids: {},
            brokeragelogsoffset: 0,
            brokeragelogs: []
        }
    }
    showBrokerageLogs(){
        var rows = [<DeveloperPortalLogsRow key="-1" logs="Logs" timestamp="Timestamp"/>]
        for(var i = 0; i < this.state.brokeragelogs.length; i++){
            var log = this.state.brokeragelogs[i]
            var thedate = new Date(log.lasttimestamp * 1000)
            rows.push(<DeveloperPortalLogsRow key={log.serial_id} logs={log.comment} timestamp={thedate.toDateString() + " " + thedate.toLocaleTimeString()}/>)
        }
        return rows
    }
    renderConstantForms(){
        var constants = this.state.constants
        var forms = []
        var keys = Object.keys(constants)
        for(var i = 0; i < keys.length; i++){
            forms.push(
                <React.Fragment><h5>{keys[i]}:</h5>
                    <input name={keys[i]} className="c_developerportal_inputonwhite" onChange={this.constantChangeHandler.bind(this)} value={parseFloat(constants[keys[i]]).toFixed(3)} placeholder={keys[i]}/>
                    <button className="c_developerportal_buttononwhite" onClick={this.updateConstant.bind(this, keys[i])}>Update</button>
                </React.Fragment>
            )
        }
        return forms
    }
    render(){
        return <div className="c_developerportal_content">
            <img src="/arthscore_equation.png" alt="ArthScore" width="100%"/><br/>
            {this.renderConstantForms()}
            <h4>Logs</h4>
            Showing {this.state.brokeragelogsoffset} - {this.state.brokeragelogsoffset + this.state.brokeragelogs.length}
            <div className="c_developerportal_searchresults">
                {this.showBrokerageLogs()}
            </div>
            <button onClick={this.decrementBrokerageLogsOffset.bind(this)} className="c_developerportal_buttononwhite">Prev</button>
            <button onClick={this.incrementBrokerageLogsOffset.bind(this)} className="c_developerportal_buttononwhite">Next</button>
        </div>
    }
    constantChangeHandler(event){
        const newstate = {...this.state}
        newstate.constants[event.target.name] = event.target.value
        this.setState(newstate)
    }
    updateConstant(key){
        var updateconstant = axios.post(ApiHelper.constants.updateConstantBySerialId, {constantid: this.state.constantids[key], value: this.state.constants[key]})
        updateconstant.then(response => {
            alert(response.data.error_message)
        }, error => {
            alert(error.response.data.error_message)
        })
    }
    decrementBrokerageLogsOffset(){
        const newstate = {...this.state}
        newstate.brokeragelogsoffset -= this.state.brokeragelogsoffset - 10 >= 0? 10: 0
        this.setState(newstate, () => {
            this.getBrokerageLogs()
        })
    }
    incrementBrokerageLogsOffset(){
        const newstate = {...this.state}
        newstate.brokeragelogsoffset += 10
        this.setState(newstate, () => {
            this.getBrokerageLogs()
        })
    }
    getBrokerageLogs(){
        var getlogs = axios.post(ApiHelper.logs.getBrokerageLogsByOffset, {offset: this.state.brokeragelogsoffset}, ApiHelper.getAccessTokenHeaderConfig())
        getlogs.then(response => {
            const newstate = {...this.state}
            newstate.brokeragelogs = response.data.data
            this.setState(newstate)
        }, error => {
            console.log(error)
        })
    }
    componentDidMount(){
        this.props.setLoading(false)
        this.getAllConstants()
        this.getBrokerageLogs()
    }
    getAllConstants(){
        var getconstants = axios.post(ApiHelper.constants.getAllConstants)
        getconstants.then(response => {
            const newstate = {...this.state}
            newstate.constants = response.data.data.constants
            newstate.constantids = response.data.data.constantids
            this.setState(newstate)
        }, error => {

        })
    }
}
export default DeveloperPortalArthScoreFactors